const dynamicCtaSelector = '.entry-content a, .textwidget.custom-html-widget a, .page-block.adspace a, .article__sidebar a';

function pushCtaEvent(ctaText, ctaLocation)
{
    //
    // Validate Values
    //
    if (!ctaText || !ctaLocation) {
        return;
    }

    //
    // Push Event
    //
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'subscription_cta_click',
        cta_text: ctaText,
        cta_location: ctaLocation,
    });
}

function isDynamicCtaCandidate(link)
{
    //
    // Get Styling Context
    //
    var style = (link.attr('style') || '').toLowerCase();
    var className = (link.attr('class') || '').toLowerCase();

    //
    // Detect Candidate
    //
    var hasButtonLikeClass = className.indexOf('btn') !== -1 || className.indexOf('button') !== -1 || className.indexOf('cta') !== -1;
    var hasButtonLikeStyle = style.indexOf('background-color') !== -1 && (style.indexOf('padding') !== -1 || style.indexOf('border-radius') !== -1 || style.indexOf('border') !== -1);
    var isWordPressButton = link.closest('.wp-block-button').length > 0;
    var isImageOnlyLink = link.find('img').length > 0 && jQuery.trim(link.text()) === '';

    return hasButtonLikeClass || hasButtonLikeStyle || isWordPressButton || isImageOnlyLink;
}

function getDynamicCtaLocation(link)
{
    //
    // Default
    //
    var ctaLocation = 'dynamic_cta';

    //
    // Resolve Context
    //
    if (link.closest('.entry-content').length) {
        ctaLocation = 'article_body_rich_text';
    }

    if (link.closest('.page-block.adspace').length) {
        ctaLocation = 'article_body_adspace';
    }

    if (link.closest('.article__sidebar').length) {
        ctaLocation = 'article_sidebar_widget';
    }

    if (link.closest('.textwidget.custom-html-widget').length) {
        ctaLocation = 'custom_html_widget';
    }

    return ctaLocation;
}

function getDynamicCtaText(link, hrefValue)
{
    //
    // Resolve Text
    //
    var ctaText = jQuery.trim(link.attr('data-cta-text') || link.text() || link.attr('aria-label') || link.attr('title') || link.find('img').attr('alt') || '');
    ctaText = ctaText.replace(/\s+/g, ' ');

    //
    // Fallback To URL Path
    //
    if (!ctaText && hrefValue) {
        try {
            ctaText = new URL(hrefValue, window.location.origin).pathname || hrefValue;
        } catch (error) {
            ctaText = hrefValue;
        }
    }

    return ctaText;
}

function bindExplicitCtaTracking()
{
    jQuery(document)
        .off('click.ctaTrackingExplicit', '[data-cta-location]')
        .on('click.ctaTrackingExplicit', '[data-cta-location]', function () {
            //
            // Get Values
            //
            var ctaText = jQuery.trim(jQuery(this).attr('data-cta-text') || jQuery(this).text() || '');
            var ctaLocation = jQuery.trim(jQuery(this).attr('data-cta-location') || '');

            pushCtaEvent(ctaText, ctaLocation);
        });
}

function bindDynamicCtaTracking()
{
    jQuery(document)
        .off('click.ctaTrackingDynamic', dynamicCtaSelector)
        .on('click.ctaTrackingDynamic', dynamicCtaSelector, function () {
            //
            // Get Element
            //
            var link = jQuery(this);
            var hrefValue = jQuery.trim(link.attr('href') || '').toLowerCase();

            //
            // Skip Existing / Invalid
            //
            if (link.attr('data-cta-location')) {
                return;
            }

            if (!hrefValue || hrefValue === '#' || hrefValue.indexOf('javascript:') === 0) {
                return;
            }

            //
            // Check Candidate
            //
            if (!isDynamicCtaCandidate(link)) {
                return;
            }

            //
            // Resolve Payload
            //
            var ctaLocation = getDynamicCtaLocation(link);
            var ctaText = getDynamicCtaText(link, hrefValue);

            pushCtaEvent(ctaText, ctaLocation);
        });
}

export function setupCtaTracking()
{
    bindExplicitCtaTracking();
    bindDynamicCtaTracking();
}
